import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-filter-by',
  templateUrl: './filter-by.component.html',
  styleUrls: ['./filter-by.component.css']
})
export class FilterByComponent implements OnInit {
  @ViewChild(MatTable) table: any;
  allColumns: string[] = []; // Array of all available columns
  selectedColumns: any = []; // Array of selected columns
  dataSource!: MatTableDataSource<any>;
  bus_nm:any
  @Output() applyFiltering: EventEmitter<any> = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<FilterByComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { allColumns: string[] } ,
    @Inject(MAT_DIALOG_DATA) public displayedColumnsObj: { displayedColumnsObj: any },
    @Inject(MAT_DIALOG_DATA) public currentfilterCriteria: { currentfilterCriteria: any }
    // Inject allColumns from parent component currentSortingCriteria
  ) {
    // Initialize allColumns array with default values
    this.allColumns = data.allColumns;
    this.bus_nm=displayedColumnsObj.displayedColumnsObj
    if(currentfilterCriteria.currentfilterCriteria){
     // this.dataSource=currentfilterCriteria.currentfilterCriteria
      this.dataSource = new MatTableDataSource(currentfilterCriteria.currentfilterCriteria);
      console.log(this.dataSource);
      
    }
    

    console.log(this.bus_nm);
    
  }
  ngOnInit(): void {
    
  }

  addColumn(columnName: string): void {
    if (!this.selectedColumns.some((col:any) => col.name === columnName)) {
      this.selectedColumns.push({ name: columnName});
      console.log(this.selectedColumns);
      this.updateDataSourceAndDetectChanges()
      
    }
  }
  updateDataSourceAndDetectChanges(): void {
    // Update your data source
    this.dataSource = new MatTableDataSource(this.selectedColumns);
  
    // Trigger change detection
    this.cdr.detectChanges();
  }

  deleteRow(row: any): void {
    // Add logic to delete row
    console.log('Deleting row:', row);
    // Here, you can remove the selected row from the dataSource array
    console.log(this.dataSource);
    const index = this.dataSource.data?.indexOf(row);
    console.log(this.dataSource.data,index);
    
    if (index !== -1) {
      this.dataSource.data.splice(index, 1);
      this.updateDataSourceAndDetectChanges()
    }
    
  }


  sortingCriteria:any
  filterQuery:any
  apply(): void {
   
    console.log(this.dataSource.data);
    if(this.dataSource.data.length>0){
      let preserveState=this.dataSource.data
      this.filterQuery = 
        this.dataSource.data.map(filter => {
         const condition:any = {};
         condition[filter.name] = { "=": filter.value };
         return condition;
       })
     
   
     
     this.applyFiltering.emit({'filter':this.filterQuery,'preserveState':preserveState}); 
    }
   
  
    
    this.dialogRef.close(); 
    
   
  }

  cancel(): void {
    this.dialogRef.close();
  }


}

